/* qx-core :: track.js */
function qxTrackEvent(name, params) {
    try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(Object.assign({ event: name, qx_build: QX.build, qx_chunk: QX.chunk, qx_edge: QX.edge }, params || {}));
        if (window.gtag) window.gtag('event', name, params || {});
    } catch (e) {}
}

function qxConvPing(stage, value) {
    QX.seq += 1;
    qxTrackEvent('qx_conv_' + stage, { qx_seq: QX.seq, value: value || 0, currency: 'EUR' });
}
